/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module browser/modules/viewport-monitor */
import { ViewportMonitor } from '../classes/viewport-monitor.js';
var viewportMonitor = new ViewportMonitor();
export { viewportMonitor };